import React from 'react';
import { useTypewriter } from '../hooks/useTypewriter';

const TypewriterHeading = ({ text, tabIndex }) => {
  const { displayText, cursorBlink } = useTypewriter(text, tabIndex);

  return (
    <h1 className="text-5xl font-bold mb-4 text-ink" aria-live="polite">
      {displayText}
      <span
        className={cursorBlink ? 'typewriter-cursor' : ''}
        aria-hidden="true"
      >
        |
      </span>
    </h1>
  );
};

export default TypewriterHeading;
